import { env as publicEnv } from '$env/dynamic/public';

export enum GreenhouseBoardId {
  BLOCK = 'block',
  BLOCKSYNCINGSANDBOX = 'blocksyncingsandbox'
}

export const GREENHOUSE_BOARD_ID =
  GreenhouseBoardId[
    publicEnv.PUBLIC_GREENHOUSE_BOARD?.toUpperCase() as keyof typeof GreenhouseBoardId
  ] ?? GreenhouseBoardId.BLOCK;
